import { css } from 'linaria';

export const stepContainer = css`
  width: 100%;
`;

export const stepNumberWrapper = css`
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
`;

export const stepNumber = css`
  display: block;
  width: 40px;
  height: 40px;
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  color: var(--control-invert);
  background-color: var(--control-primary);
  border-radius: 50%;
`;

export const stepName = css`
  margin-bottom: 8px;
`;
